import { useFormContext } from '@calendly/form';
import { FieldLabel } from '@calendly/form/parts';
import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { formatDuration } from 'services/event_types';
import { DurationFields } from './duration_fields';
import { getDurationFromValues } from './format_values_to_server_data';
const styledDurationFieldsFullWidthCss = "s1uvbl3c";
const styledDurationFieldsCss = "sofnmwt";
const StyledDurationFields = forwardRef((props, ref) => {
  const {
    fullWidth,
    ...restProps
  } = props;
  const gridSizes = {
    field: 12,
    customValue: 5,
    customUnit: 7
  };
  const spreadErrorMessage = true;
  return <DurationFields ref={ref} {...restProps} gridSizes={gridSizes} spreadErrorMessage={spreadErrorMessage} className={classNames(styledDurationFieldsCss, {
    [styledDurationFieldsFullWidthCss]: fullWidth
  }, props.className)} />;
});
const durationText = duration => formatDuration(duration, undefined, true);
const DurationLocked = ({
  hideLabel
}) => {
  const {
    values
  } = useFormContext();
  const duration = getDurationFromValues(values);
  return <div>
      {!hideLabel && <FieldLabel text={I18n.t('publisher.event_types.availability.duration_fieldset.title')} proTip={I18n.t('publisher.event_types.availability.duration_fieldset.description')} isRequired />}
      <BodyText>
        {durationText(duration)}
      </BodyText>
    </div>;
};
export const Duration = ({
  isLocked,
  isReadOnly,
  ...props
}) => isLocked || isReadOnly ? <DurationLocked {...props} /> : <StyledDurationFields {...props} />;

require("./duration.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./duration.js");